/* eslint-disable @typescript-eslint/no-unused-vars */
import { HeaderLogo } from '@/components/HeaderLogo'
import { IconCartHeaderNew } from '@/components/Icon/HeaderIcon'
import { HeaderMenuWhite } from '@/components/Icon/HeaderMenuWhite'
import ImageOptimize from '@/components/ImageOptimize'
import { MenuWrapper } from '@/components/MenuWrapper'
import StickyPage from '@/components/StickyPage'
import { PageType } from '@/constants'
import { useAuth, useStore } from '@/containers'
import { useRouterBack } from '@/hooks/useRouterBack'
import { useIsomorphicLayoutEffect } from '@/utils/useIsomorphicLayoutEffect'
import {
  IconAccount,
  IconClose,
  IconsDownsLocate,
  SearchIcon
} from '@/styles/Icon'
import { Dialog, Transition } from '@headlessui/react'

import Link from 'next/link'
import { Fragment, useEffect, useMemo, useRef, useState } from 'react'
interface HeaderType {
  layout: string
  page?: string
  dataHeader: string | undefined
  btnHome?: boolean
}
// `page` vẫn nằm trong HeaderType để các nơi gọi tiếp tục truyền xuống mà
// không vỡ kiểu, nhưng Header không còn phân nhánh theo nó nữa.
// Hàng tìm kiếm chuyển sang `fixed` khi cuộn quá mốc này (px).
const HEADER_FIXED_SCROLL_Y = 10

const Header = ({ layout, dataHeader, btnHome = true }: HeaderType) => {
  const handleGoBack = useRouterBack()
  // Chỉ cập nhật scrollY khi vượt các mốc mà phần render bên dưới dùng tới
  // (0 và HEADER_FIXED_SCROLL_Y) thay vì re-render Header ở mọi sự kiện scroll.
  const [scrollY, setScrollY] = useState(0)
  // Chiều cao hàng tìm kiếm lúc còn trong flow. Khi hàng này chuyển sang
  // `fixed` (rời normal flow) header co lại ~39px và kéo toàn bộ nội dung lên
  // (CLS khi cuộn) -> chèn khối cùng màu header ngay dưới header để giữ chỗ.
  const searchRowRef = useRef<HTMLDivElement>(null)
  const headerRef = useRef<HTMLElement>(null)
  const expandedHeaderHeight = useRef(0)
  const [searchRowHeight, setSearchRowHeight] = useState(0)
  useEffect(() => {
    const bucket = (y: number) =>
      y <= 0
        ? 0
        : y < HEADER_FIXED_SCROLL_Y
        ? 1
        : y === HEADER_FIXED_SCROLL_Y
        ? 2
        : 3
    const handleScroll = () => {
      const y = document.documentElement.scrollTop
      const row = searchRowRef.current
      if (
        y <= HEADER_FIXED_SCROLL_Y &&
        row &&
        getComputedStyle(row).position !== 'fixed'
      ) {
        setSearchRowHeight(row.offsetHeight)
        if (headerRef.current) {
          expandedHeaderHeight.current = headerRef.current.offsetHeight
        }
      }
      setScrollY(prev => (bucket(prev) === bucket(y) ? prev : y))
    }
    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
  // Chỉnh khối giữ chỗ cho khớp tuyệt đối phần header thực sự co lại (hàng
  // tìm kiếm + các chi tiết ẩn theo scroll), chạy trước khi trình duyệt vẽ.
  const isSearchRowFixed = scrollY > HEADER_FIXED_SCROLL_Y
  useIsomorphicLayoutEffect(() => {
    if (!isSearchRowFixed || !headerRef.current || !expandedHeaderHeight.current)
      return
    const shrunk = expandedHeaderHeight.current - headerRef.current.offsetHeight
    if (shrunk > 0) setSearchRowHeight(shrunk)
  }, [isSearchRowFixed])

  const { regions, saleRegion, setIsOpenPopupLocation, megaMenu } = useStore()
  const store = regions.find(e => e.code === saleRegion)
  const { user, cart } = useAuth()
  const [open, setOpen] = useState(false)
  const closeModal = () => {
    setOpen(false)
  }

  const fixedScrollY = 10;

  const headerDefault = useMemo(() => {
    return (
      <StickyPage title={dataHeader as string} />
    )
  }, [dataHeader])

  const checkLayout = (layout:string) => {
    if([PageType.HOMEPAGE as string, PageType.CATEGORY as string, PageType.PRODUCT as string, PageType.CHECKOUT as string, PageType.POST as string, PageType.PAGE_CMS as string].includes(layout)) {
      return true
    }
    return false;
  }

  return (


    <>
    <header
      ref={headerRef}
      className={`${scrollY > 0 && checkLayout(layout) ? 'bg-header-mb fixed' : ''
        } ${dataHeader != PageType.HOMEPAGE ? '' : 'bg-header-mb'} ${layout == '' ? 'bg-header-mb' : ''
        } sticky top-0 z-[999] px-2 py-2 w-full max-w-[440px] bg-header-mb `}
    >
      {checkLayout(layout) && (
        <>
          <div className={`w-full flex items-center flex-col text-white relative`}>
            <div className='absolute z-[999] flex items-center left-0 top-0 w-[47px] h-[47px]'  onClick={() => setOpen(true)}>
              <HeaderMenuWhite />
            </div>
            <div className='w-full relative flex items-center justify-between mb-1'>
              <div className={`flex items-center justify-center w-full relative transition-all duration-100 ease-out ${scrollY < 10 ? '': 'opacity-0'}`}>
                {/* Logo không bọc trong <h1>: H1 của trang chủ là tiêu đề mô
                    tả chủ đề trang (xem src/pages/index.tsx), không phải logo. */}
                <div className='block'>
                  <Link href={'/'} aria-label='Pico - Trang chủ'>
                    <HeaderLogo />
                  </Link>
                </div>
              </div>
            </div>
            
            <div className={`flex gap-2 items-center justify-end absolute right-0 top-0 z-[999] h-[47px]`}>
              <div className={`relative transition-all duration-100 ease-out ${scrollY < 10 ? '': 'opacity-0'}`}>
                <Link
                  className='account relative max-w-[36px]'
                  href='/account'
                  aria-label='Tài khoản'
                >
                  <div
                    className={`avt rounded-full w-[30px] overflow-hidden flex items-center justify-center`}
                  >
                    {user ? (
                      user?.avatarImage ? (
                        <ImageOptimize
                          src={user?.avatarImage}
                          alt={user?.name}
                          width={100}
                          height={100}
                          className='aspect-square object-cover w-full rounded-full'
                        />
                      ):(
                        <ImageOptimize
                        src={'/assets/icons/icon-user-df.svg'}
                        alt={user?.name}
                        width={100}
                        height={100}
                        className='aspect-square object-cover w-full rounded-full'
                      />
                      )
                    ) : (<IconAccount color='white' />)}
                    
                  </div>
                </Link>
              </div>

              <div className='relative'>
                <Link href={'/checkout/cart'} aria-label='Giỏ hàng'>
                  <span className='absolute top-[-4px] right-[0px] rounded-full bg-[#E89700] text-xs flex items-center justify-center min-w-[16px] px-1 leading-4'>
                    {cart && cart.quantity && cart.quantity > 9
                    ? '9+'
                    : cart.quantity}
                  </span>
                  <div className='bg-[#BC0000] rounded-full p-[5px] block'>
                    <IconCartHeaderNew color={'white'} />
                  </div>
                </Link>
              </div>
            </div>

            <div ref={searchRowRef} className={`w-full flex gap-2 ${scrollY > fixedScrollY && 'fixed mx-auto max-w-[440px] justify-center top-[12px] px-4  transition-all ease-out duration-500'}`}>
              <div className={`flex items-center justify-between relative gap-2 w-10/12 `}>
                <Link
                  href={'/search'}
                  className='flex w-full flex-1 items-center justify-between gap-2 overflow-hidden rounded-md bg-white-500 py-2 pl-3 pr-4'
                >
                  <SearchIcon />
                  <span className='flex-1 text-[14px] text-[#000000]/50'>
                    Bạn cần tìm gì hôm nay?
                  </span>
                </Link>

              </div>

                {scrollY < 10 && (
                  <div className='flex items-center justify-end'>
                    <div
                      className='flex items-center cursor-pointer bg-white/30 px-2 py-3 rounded-sm overflow-clip whitespace-nowrap max-w-[95%]'
                      onClick={() => setIsOpenPopupLocation(true)}
                    >
                      <span className='line-clamp-2 text-xs leading-tight pr-2'>
                        {store?.name}
                      </span>
                      <IconsDownsLocate color='white' />
                    </div>
                  </div>
                )}
            </div>

            </div>  

            
          {/* -------------------- */}

          <Transition.Root show={open} as={Fragment}>
                    <Dialog as='div' className='relative  z-[9999]' onClose={setOpen}>
                      <Transition.Child
                        as={Fragment}
                        enter='ease-in-out duration-500'
                        enterFrom='opacity-0'
                        enterTo='opacity-100'
                        leave='ease-in-out duration-500'
                        leaveFrom='opacity-100'
                        leaveTo='opacity-0'
                      >
                        <div className='fixed inset-0 left-0 bg-gray-500 bg-opacity-75 transition-opacity' />
                      </Transition.Child>
          
                      <div className='fixed inset-0 overflow-hidden'>
                        <div className='pointer-events-none fixed inset-y-0 left-[50%] translate-x-[-50%] flex max-w-[440px]'>
                          <Transition.Child
                            as={Fragment}
                            enter='transform transition ease-in-out duration-500 sm:duration-700'
                            enterFrom='translate-x-[-100%] opacity-0'
                            enterTo='translate-x-[0%] opacity-100'
                            leave='transform transition ease-in-out duration-500 sm:duration-700'
                            leaveFrom='translate-x-[0%] opacity-100'
                            leaveTo='translate-x-[-100%] opacity-0'
                          >
                            <Dialog.Panel className='pointer-events-auto w-screen max-w-md'>
                              <div className='flex h-full flex-col bg-white relative'>
                                <span
                                  className='absolute block right-4 z-10 top-9'
                                  onClick={closeModal}
                                >
                                  <IconClose />
                                </span>
                                <MenuWrapper
                                  megaMenuData={megaMenu}
                                  closeModal={closeModal}
                                />
                              </div>
                            </Dialog.Panel>
                          </Transition.Child>
                        </div>
                      </div>
                    </Dialog>
                  </Transition.Root>

        </>

      )}

      {layout == '' && headerDefault}
    </header>
    {/* Giữ chỗ cho hàng tìm kiếm đã chuyển sang fixed (xem searchRowHeight).
        Nằm ngoài header nên cuộn đi cùng nội dung, header vẫn co lại như cũ. */}
    {checkLayout(layout) && scrollY > fixedScrollY && (
      <div
        aria-hidden='true'
        className='w-full max-w-[440px] bg-header-mb'
        style={{ height: searchRowHeight }}
      />
    )}
    </>
  )
}
export { Header }

